// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__xzC5t","header":"ReportDetails_header__Kyhia","title":"ReportDetails_title__2_lDU","left":"ReportDetails_left__283Fl"};